<template>
  <Modal
    :headline="$t('language.languageDialog')"
    :save-btn-disabled="!languagesSelected"
    :save-btn-name="$t('app.save')"
    :show-cancel-btn="false"
    :show-modal="showModal"
    @save="setLanguageInDB"
    @cancel="showModal = false">
    <v-select
      class="mt-3"
      :label="$t('app.appLanguage')"
      :items="availableLanguageNames"
      v-model="appLanguage"
      @change="$i18n.locale = $event"
      :hint="$t('language.appLanguageHint')"
      persistent-hint
      outlined />
    <v-select
      class="mt-6"
      :items="languageList"
      v-model="languages.base"
      :label="$t('app.baseLanguage')"
      :hint="$t('language.baseLanguageHint')"
      persistent-hint
      outlined />
    <v-select
      class="mt-6"
      :items="languageList"
      v-model="languages.learning"
      :label="$t('app.learningLanguage')"
      :hint="$t('language.learningLanguageHint')"
      persistent-hint
      outlined />
    <p v-if="languagesSelected && duplicateLanguage" style="color: red;">
      {{ $t('language.duplicateLanguage') }}
    </p>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@components/modal';
import availableLanguages from '@/config/languages';
import updateDataFrom from '@/mixins/firestore/updateDataFrom';
import { USERS } from '@/config/firestore';

export default {
  name: 'LanguageDialog',
  components: {
    Modal,
  },
  mixins: [updateDataFrom],
  data: () => ({
    showModal: true,
    languages: {
      base: '',
      learning: '',
    },
    appLanguage: '',
    availableLanguages,
  }),
  computed: {
    ...mapGetters('user', ['hasUserLanguages']),

    languagesSelected() {
      return Object.keys(this.languages).every((lang) => this.languages[lang].length > 0);
    },
    duplicateLanguage() {
      return this.languages.base === this.languages.learning;
    },
    availableLanguageNames() {
      return this.availableLanguages.map((code) => this.$lang.getNativeName(code));
    },
    languageList() {
      return this.$lang.getAllNativeNames();
    },
    appLanguageCode() {
      return this.$lang.getCode(this.appLanguage);
    },
    baseLanguageCode() {
      return this.$lang.getCode(this.languages.base);
    },
    learningLanguageCode() {
      return this.$lang.getCode(this.languages.learning);
    },
  },
  methods: {
    ...mapActions('user', ['setUserLanguages', 'setAppLanguage']),

    setLanguageInDB() {
      this.showModal = false;
      this.updateDataFrom(USERS, { appLanguage: this.appLanguageCode });
      this.updateDataFrom(USERS, { baseLanguage: this.baseLanguageCode });
      this.updateDataFrom(USERS, { learningLanguage: this.learningLanguageCode });

      this.setAppLanguage(this.appLanguageCode);
      this.setUserLanguages({
        base: this.baseLanguageCode,
        learning: this.learningLanguageCode,
      });
    },
    initAppLanguage() {
      const browserLanguage = (window.navigator.userLanguage || window.navigator.language).slice(0, 2);
      if (availableLanguages.includes(browserLanguage)) {
        this.$i18n.locale = browserLanguage;
        this.appLanguage = this.$lang.getNativeName(browserLanguage);
      }
    },
  },
  watch: {
    showModal() {
      if (!this.hasUserLanguages) {
        this.showModal = true;
      }
    },
  },
  created() {
    this.initAppLanguage();
  },
};
</script>
